import { h, Component } from 'preact';
import s from 'base/error404/error404App.sss';

export default class Error404App extends Component {

	constructor(props) {
		super(props);
		this.updateTime = this.updateTime.bind(this);
	
		let data = props.initialStore;
		this.state = {
			errorMessage: data.errorMessage,
			redirectMessage: data.redirectMessage,
			destination: data.destination,
			tertiaryTextColor: data.tertiaryTextColor,
			tertiaryBackgroundColor: data.tertiaryBackgroundColor
		};
	}

	componentDidMount() {
		this.startTimer();
	}

	componentWillUnmount() {
		this.stopTimer();
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.count !== this.state.count && this.state.count === 0) {
			this.redirect();
		}
	}

	getFinalUrl() {
		let destination = this.state.destination;
		if (destination && !/(\/\/.+)(\/.+\..+|\/)$/.test(destination)) {
			destination += '/';
		}
		if (destination && typeof location !== 'undefined') {
			destination += location.search;
		}
		return destination;
	}

	startTimer() {
		this.setState({ count: 3 });
		this.timer = setInterval(this.updateTime, 1000);
	}
	stopTimer() {
		clearInterval(this.timer);
		this.timer = null;
	}

	updateTime() {
		this.setState({ count: Math.max(this.state.count - 1, 0) });
	}

	redirect() {
		this.stopTimer();
		let destination = this.getFinalUrl();
		if (destination) {
			location.href = destination;
		}
	}

	render(props, state) {
		const { errorMessage, count, tertiaryTextColor, tertiaryBackgroundColor, redirectMessage } = state;
		let mainText = count;

		if (mainText === undefined) {
			let destination = this.getFinalUrl();
			mainText = <span>Redirecting to <a href={destination}>{destination}</a></span>;
		} else if (mainText === 0) {
			let destination = this.getFinalUrl();
			mainText = <a href={destination}>{redirectMessage || 'Continue here if nothing happens'}</a>;
		}

		return (
			<div class={s.wrapper} style={{ color: tertiaryTextColor, backgroundColor: tertiaryBackgroundColor }}>
				<div class={s.container}>
					<div class={s.info}>
						<div class={s.errorMessage}>{errorMessage}</div>
					</div>
					<div class={s.mainText}>{mainText}</div>
				</div>
			</div>
		);
	}

}
